import { Either, isLeft, isRight, left, right } from "fp-ts/lib/Either";
import ExceptionEntity from "../../../../../domain/entities/ExceptionEntity";
import GraphApi from "../../../../settings/GraphApi";
import DateParse from "../../../../../ui/utils/DateParse";

const PauseTrackingClockApiImpl = async (reason: string, shiftId: string): Promise<Either<ExceptionEntity, void>> => {
    const response = await GraphApi.multipleMutation([{
        name: 'updateTime_tracking',
        params: {
            updateTime_trackingInput: {
                shift_id: parseInt(shiftId),
                clock_out_time: DateParse.formatDate(new Date()),
            }
        },
        results: ['activity_type_id', 'clock_in_time', 'clock_out_time', 'details', 'shift_id', 'tag_type_id', 'time_tracking_id']
    },
    {
        name: 'createTime_tracking',
        params: {
            createTime_trackingInput: { activity_type_id: 7, clock_in_time: DateParse.formatDate(new Date()), clock_out_time: "", details: 'pause_' + reason, shift_id: shiftId, tag_type_id: parseInt('26') },
        },
        results: ['clock_in_time', 'activity_type_id', 'clock_out_time', 'details', 'shift_id', 'tag_type_id', 'time_tracking_id']
    }
    ]);
    
    // Check if response is successful
    if (isRight(response)) {
        // Both mutations succeeded
        const responseData = response.right;
        const data = responseData?.data;
        
        // Verify both mutations have data
        const updateSuccess = data?.updateTime_tracking != null;
        const createSuccess = data?.createTime_tracking != null;
        
        
        return response;
    }
    
    // Response has errors - need to check which mutation failed
    if (isLeft(response)) {
        const error = response.left;
        const errorMessage = error.message || '';
        
        
        // GraphQL can return both errors and data in the same response
        // However, GraphApi.multipleMutation returns error if ANY error exists
        // We need to check the error message to determine which mutation failed
        
        // Check error message patterns to identify which mutation failed
        const isUpdateError = errorMessage.includes("Selected id does not exist in table database") || 
                             errorMessage.includes("updateTime_tracking") ||
                             errorMessage.includes("EditTimetracking");
        
        const isCreateError = errorMessage.includes("createTime_tracking") ||
                             errorMessage.includes("CreateTimetracking");
        
        if (isUpdateError && !isCreateError) {
            // Update failed but create likely succeeded - return success
            return right(undefined);
        } else if (isCreateError) {
            return response;
        } else {
            // Unknown error - return error
            return response;
        }
    }
    
    return response;
}

export default PauseTrackingClockApiImpl;